<template>
  <div class="login">
    <div class="login-page">
    <div class="login-title-container">
      <h4  class="login-title" >欢迎登录<span style="color:#3A82FF">违章查询处理</span></h4>
      <p class="login-content">齐车大圣为您提供全面、精准、快速的违章查询处理服务，为您轻松代办。</p>
    </div>
      <div :class="isTelTrue ? 's4s-group' : 's4s-group s4s-group-error'" >
        <div class="s4s-group-tit">手机号码</div>
        <input type="number" maxlength="11" v-model="userTel" placeholder="请输入手机号码">
      </div>
      <div :class="isCodeTrue ? 's4s-group' : 's4s-group s4s-group-error'" >
        <div class="s4s-group-tit">验证码</div>
        <input type="text" style="width: 6em;" maxlength="4"  v-model="code"  placeholder="请输入验证码">
        <a class="s4s-group-btn" @click="sendCode" >{{btnText}}</a>
      </div>
    </div>
    <p v-if="error" class="s4s-error">{{error}}</p>
    <a class="s4s-btn" @click="goLogin" :style="{backgroundImage:advertisingShow.backgroundImage}">登录</a>
    <p class="login-rule">登录即代表您已同意<span  style="color:#3A82FF" @click="gotoRule">《服务协议》</span>。</p>
  </div>
</template>
<script>
import advertisingShow from './../utils/advertising';

export default {
  name: 'login',
  data() {
    return {
      userTel: '',
      code: '',
      btnText: '获取验证码',
      leftTime: 60,
      timer: null,
      disable: false,
      isTelTrue: true,
      isCodeTrue: true,
      error: '',
      advertisingShow: advertisingShow(),
    };
  },
  mounted() {
    console.log(this.$route);
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '登录'
      });
    }
  },
  methods: {
    sendCode() {
      this.isTelTrue = true;
      this.isCodeTrue = true;
      this.error = '';
      const telReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!telReg.test(this.userTel)) {
        this.isTelTrue = false;
        this.error = '请输入正确的手机号码';
        return;
      }
      if (this.disable) {
        return;
      }
      this.disable = true;
      this.leftTime = 60;
      this.btnText = `${this.leftTime}s后重发`;
      this.timer = setInterval(() => { this.enableResend(); }, 1000);
      const param = {
        tel: this.userTel,
      };
      this.$request('v5/user/code', param)
        .then((xhr, res) => {
          if (res.code > 0) {
            this.$showToast({
              title: res.msg,
            });
          } else {
            this.$showToast({
              title: '发送成功',
            });
          }
        }).catch((e) => {
          console.log('catch', e);
          this.$showToast({
            title: '发送验证码失败，请重试',
          });
          clearInterval(this.timer);
        });
    },
    enableResend() {
      this.btnText = `${this.leftTime - 1}s后重发`;
      this.leftTime -= 1;
      if (this.leftTime <= 0) {
        this.disable = false;
        clearInterval(this.timer);
        this.btnText = '获取验证码';
      }
    },
    goLogin() {
      const that = this;
      this.isTelTrue = true;
      this.isCodeTrue = true;
      this.error = '';
      const telReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!telReg.test(this.userTel)) {
        this.isTelTrue = false;
        this.error = '请输入正确的手机号码';
        return;
      }
      if (this.code.length < 4) {
        this.isCodeTrue = false;
        this.error = '请输入验证码';
        return;
      }
      const param = {
        tel: this.userTel,
        code: this.code,
      };
      this.$request('v5/user/login', param).then((xhr, res) => {
        if (res.code === 0) {
          // 登录成功
          that.$store.commit('SET_TOKEN', res.data.Token);
          that.$store.commit('SET_USERINFO', res.data.User);
          if (this.$store.getters.channel) {
            this.$request('v3/violation/car/manage', this.$store.getters.scottCarParam).then((xhrr, ress) => {
              if (ress.code === 0) {
                console.log('加载列表');
              }
            }).catch((e) => {
              console.log(e);
            });
          }
          if (that.$route.query.redirect) {
            that.$router.replace({
              path: this.$route.query.redirect || '/',
              query: {
                ...this.$route.query,
              },
            });
          } else {
            that.$router.go(-1);
          }
        } else {
          this.$showToast({
            title: res.msg,
          });
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    gotoRule() {
      this.$router.push({
        name: 'agreement',
      });
    },
  },
  watch: {
    userTel(val) {
      this.userTel = val.substring(0, 11);
    },
  },
};
</script>
<style lang="scss" scoped="" type="text/css">
.login {
  padding: 10px 15px;
  &-page {
    background: #ffffff;
    box-shadow: 0 2px 4px 0 #efefef;
    border-radius: 2px;
    padding: 0 15px;
    margin-bottom: 10px;
  }
  &-content {
    color: #9c9ea8;
  }
  &-title {
    padding-top: 10px;
    font-size: 22px;
    &-container {
      margin-bottom: 45px;
    }
  }
  &-rule {
    font-size: 12px;
    margin-top: 15px;
    color: #9c9ea8;
  }
}
.s4s-btn {
  display: block;
  width: 100%;
  margin: 50px 0 12px;
}
.s4s-group-btn {
  min-width: 6em;
  text-align: center;
  color: #3a82ff;
  border: 1px solid #3a82ff;
  font-size: 12px;
  line-height: 26px;
  // margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  box-sizing: border-box;
}

.s4s-group.s4s-group-error {
  border-bottom: 1px #fd2900 solid !important;
}

.s4s-group.s4s-group-error input {
  color: #fd2900 !important;
}

.s4s-error {
  font-size: 12px;
  line-height: 17px;
  color: #fd2900;
  margin-top: 13px;
}
</style>
